module.exports = __webpack_public_path__ + "img/align-justify.0176a1a9.svg";